import { useCallback, useState } from 'react';
export const useExpandedSections = () => {
  const [expandedSections, setExpandedSections] = useState({});
  const toggleExpand = useCallback(index => () => {
    setExpandedSections(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  }, [setExpandedSections]);
  return [expandedSections, toggleExpand];
};